module.exports = [
	{
		"componentChunkName": "component---src-templates-post-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "posts-2017-07-21-building-a-blog-with-gatsby-pt-1.json",
		"path": "/posts/2017/07/21/building-a-blog-with-gatsby-pt-1/"
	},
	{
		"componentChunkName": "component---src-templates-post-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "posts-2017-07-18-welcome.json",
		"path": "/posts/2017/07/18/welcome/"
	},
	{
		"componentChunkName": "component---src-templates-post-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "posts-2017-08-02-building-a-blog-with-gatsby-pt-2.json",
		"path": "/posts/2017/08/02/building-a-blog-with-gatsby-pt-2/"
	},
	{
		"componentChunkName": "component---src-templates-tag-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "tags-java-script.json",
		"path": "/tags/java-script/"
	},
	{
		"componentChunkName": "component---src-templates-tag-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "tags-react.json",
		"path": "/tags/react/"
	},
	{
		"componentChunkName": "component---src-templates-tag-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "tags-tutorial.json",
		"path": "/tags/tutorial/"
	},
	{
		"componentChunkName": "component---src-templates-tag-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "tags-random.json",
		"path": "/tags/random/"
	},
	{
		"componentChunkName": "component---src-templates-tag-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "tags-gatsby.json",
		"path": "/tags/gatsby/"
	},
	{
		"componentChunkName": "component---src-pages-index-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "index.json",
		"path": "/"
	},
	{
		"componentChunkName": "component---src-pages-posts-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "posts.json",
		"path": "/posts/"
	},
	{
		"componentChunkName": "component---src-pages-projects-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "projects.json",
		"path": "/projects/"
	},
	{
		"componentChunkName": "component---src-pages-tags-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "tags.json",
		"path": "/tags/"
	},
	{
		"componentChunkName": "component---src-pages-404-index-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "404.json",
		"path": "/404/"
	},
	{
		"componentChunkName": "component---src-pages-404-index-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "404-html.json",
		"path": "/404.html"
	},
	{
		"componentChunkName": "component---src-pages-contact-index-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "contact.json",
		"path": "/contact/"
	}
];


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = ./.cache/pages.json
// module chunks = 231608221292675